<template>
    <li>
        <!-- 썸네일 이미지 -->
        <div class="thumb" v-if="isNotEmpty(story.thumbnail)">
            <a :href="storyViewUrl" :title="story.title" target="_blank">
                <img :src="story.thumbnail" width="230" height="130" :alt="titleText+' 이미지 입니다.'">
                <span class="source-origin" v-html="showStoryThumbnailCopyright(story)"></span>
            </a>
        </div>
        <!-- 내용 부분 -->
        <div class="data-wrap">
            <dl>
                <dt>
                    <p class="classification">
                        <em class="regional" v-if=" !isEmpty(story.province) ">{{ story.province.name }}</em>
                        <span v-if=" !isEmpty(story.province) && !isEmpty(story.city) " class="arr">&gt;</span>
                        <em class="regional" v-if=" !isEmpty(story.city) ">{{ story.city.name }}</em>
                        <span class="bar" v-if=" getCouncilName(story) !== '' ">{{ getCouncilName(story) }}</span>
                    </p>
                    <a :href="storyViewUrl" :title="titleText" v-html="titleHtml" target="_blank"></a>
                </dt>
                <dd v-html="summaryHtml"></dd>
            </dl>

            <p class="list-info">{{ getTopicWithChildTopic(story) }}
                <span class="bar" v-show="getCouncilsName(story).length>0">
                    <strong>관련문화원 : </strong>{{ getCouncilsName(story) }}
                </span>
            </p>
            <!-- 태그 목록 -->
            <ul class="list-tag" v-if=" !isEmpty(story.tags) && story.tags.length>0 ">
                <story-tag
                    v-for="tag in story.tags"
                    :key="tag.id"
                    :tag="tag"
                    :theme="theme"
                ></story-tag>
            </ul>
        </div>

    </li>
</template>

<script>
import StoryTag from "./StoryTag.vue";

export default {
    components: {
        StoryTag // 태그용
    },
    props: {
        story: { type: Object, required: true }, // 스토리 객체
        theme: { type: String }, // 테마 이름
        listViewType: { type: String},  // 선택된 목록 보기 방식
    },
    computed: { 
        // 스토리 상세보기 주소 정보
        storyViewUrl() {
            return `/${this.theme}/story/${this.story.id}`; // [ES6+]
        },
        titleHtml() {
            return this.story.title.replace(/<!HS>/gi,'<span class="find">').replace(/<!HE>/gi,'</span>');
        },
        titleText() {
            return this.story.title.replace(/<!HS>/gi,"").replace(/<!HE>/gi,"");
        },
        summaryHtml() {
            return this.story.summary.replace(/<!HS>/gi,'<span class="find">').replace(/<!HE>/gi,'</span>');
        }
    },
    methods: {
        // 썸네일 보임 여부
        isShowThumbnail(thumbnail) {
            if( thumbnail == "" || thumbnail == null || thumbnail == undefined ||
                    ( thumbnail != null && typeof thumbnail == "object" && !Object.keys(thumbnail).length ) ){
                return false;
            } else {
                return true;
            }
        },
        // 토픽>차일드 토픽 형식으로 토픽이름 설정
        getTopicWithChildTopic(story) {
            // let topic = this.getTopicName(story);
            let topic = this.isEmpty(this.story.topic) ? null : this.story.topic.name ;
            // let childTopic = this.getChildTopicName(story);
            let childTopic = this.isEmpty(this.story.child_topic) ? null : this.story.child_topic.name;

            if (childTopic != null && childTopic.length > 0) {
                topic += ' > ' + childTopic;
            }

            // 화면이 안 틀어지도록 공백으로 채움
            if (topic === null || topic === '') {
                topic = '                    '; // topic = ' '.repeat(20); 
            }

            return topic;
        },
        // 소속문화원 이름
        getCouncilName() {
            let councilName = '';
            try {
                if( !this.isEmpty(this.story.relate_council_list) ) {
                    councilName = this.story.relate_council_list[0].name;
                }
            } catch (error) { councilName = ''; }
            return councilName;
        },
        // 관련 문화원 이름
        getCouncilsName() {
            let councilsName = '';
            try {
                if( !this.isEmpty(this.story.relate_council_list) ) {
                    for (let i = 0; i < this.story.relate_council_list.length; i++) {
                        if (councilsName != ''){
                            councilsName += ', '+this.story.relate_council_list[i].name;
                        }else{
                            councilsName = this.story.relate_council_list[i].name;
                        }
                    }
                } 
            } catch (error) { councilsName = ''; }
            return councilsName;
        },
        showStoryThumbnailCopyright(story){
            if (story.thumbnail_copyright != null && story.thumbnail_copyright != '' && story.thumbnail_copyright != '한국문화원연합회') {
               return '사진출처: ' + story.thumbnail_copyright;
            } else
                return '';
        }
        // value값이 비었는지 여부 체크 (js특성)
        // isEmpty(value){ /* app.js에서 전역으로.. */ }
    }
}
</script>